<template>
    <a v-if="link" target="_blank" :href="link" v-tooltip="$t('livestream.open_livestream_link_tooltip')">
        <small>{{ $t('livestream.open_livestream_link_text') }}</small>
    </a>
</template>

<script setup>

    import { computed } from 'vue';

    const props = defineProps({
        ceremony: {
            type: Object,
            required: true,
        },
    });

    const link = computed(() => {
        if (props.ceremony.cleaned_up_at) {
            return null;
        }

        const ceremonyEventId = props.ceremony.livestream_event_id;
        const streamingHost = props.ceremony.location?.livestream_platform_url;

        if (!ceremonyEventId || !streamingHost) {
            return null;
        }

        return `${streamingHost}/account/event/${ceremonyEventId}/edit`;
    });

</script>
